import { useState, useEffect } from "react";
import { Example } from "./Example";
import { getCategoryExamplesApi } from "../../api"; // Import the API function

import styles from "./Example.module.css";

interface Props {
    onExampleClicked: (value: string) => void;
    /** Categories selected by the user in settings, used to fetch relevant examples. */
    selectedCategories: string[];
    /** Categories the user has access to. */
    userCategories: string[];
}

export const ExampleList = ({ onExampleClicked, selectedCategories, userCategories }: Props) => {
    const [examples, setExamples] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchExamples = async () => {
            setIsLoading(true);
            try {
                // Determine the categories to actually fetch examples for
                // If no categories are selected in settings, use all the user's available categories.
                // Otherwise, use the intersection of selected categories and user's available categories.
                const categoriesToFetch = selectedCategories.length === 0 ? userCategories : selectedCategories.filter(cat => userCategories.includes(cat));

                const fetchedExamples = await getCategoryExamplesApi(categoriesToFetch);
                setExamples(fetchedExamples); // The API function now returns the final 3 random examples
            } catch (error) {
                console.error("Failed to fetch examples:", error);
                setExamples([]); // Set empty or default examples on error
            } finally {
                setIsLoading(false);
            }
        };

        fetchExamples();
    }, [selectedCategories, userCategories]); // Re-fetch when selected or available categories change

    const categoriesToFetch = selectedCategories.length === 0 ? userCategories : selectedCategories.filter(cat => userCategories.includes(cat));

    return (
        <ul className={styles.examplesNavList}>
            {isLoading ? (
                // Optional: Add a loading indicator
                // <li>Loading examples...</li>
                // show categoriesToFetch in the indicator
                <li>Loading examples for categories: {categoriesToFetch.join(", ")}</li>
            ) : (
                examples.map((question, i) => (
                    <li key={i}>
                        <Example text={question} value={question} onClick={onExampleClicked} />
                    </li>
                ))
            )}
        </ul>
    );
};
